import {
  request
} from './index'
import Storage from '@tencent/vft-common/Storage'

const baseUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi'

export default {
  isFirst() {
    let visible = Storage.get('d2d_cny_visible')
    Storage.set('d2d_cny_visible', 'false')

    return visible !== 'false'
  },

  getEggType () {
    return request({
      url: baseUrl,
      data : {
        name: 'spp_year_eggs_star',
        cmd: 65395
      }
    })
  },

  getEggInfo() {
    return request({
      url: baseUrl,
      data: {
        name: 'cny_eggs_mgr_read_svr',
        cmd: 1
      }
    })
  },

  getMsg(query) {
    return request({
      url: baseUrl,
      data: {
        name: 'cny_eggs_mgr_read_svr',
        cmd: 3,
        page_size: query.pageSize,
        page_idx: query.pageIndex
      }
    })
  },

  getFriendship() {
    return request({
      url: baseUrl,
      data: {
        name: 'cny_eggs_mgr_read_svr',
        cmd: 2
      }
    })
  },

  getMyRecord(query) {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr',
        cmd: 1,
        page_size: query.pageSize,
        page_index: query.pageIndex
      }
    })
  },

  getRecord() {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr_noverify',
        cmd: 2
      }
    })
  },

  getLeaderboard() {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr_noverify',
        cmd: 3
      }
    })
  },

  getStatisticData() {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr_noverify',
        cmd: 4
      }
    })
  },

  getUnReadAwardList() {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr',
        cmd: 6
      }
    })
  },

  getShareCode() {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_year_eggs_collision',
        cmd: 65391
      }
    })
  },

  getInfoByShareCode(shareCode) {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_year_eggs_collision',
        cmd: 65393,
        share_code: shareCode
      }
    })
  },

  pengdan(shareCode) {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_year_eggs_collision',
        cmd: 65394,
        share_code: shareCode
      }
    })
  },

  shortUrl(url) {
    return request({
      url: baseUrl,
      data: {
        name: 'short_url',
        url,
        need_short_url: 1,
        need_qrcode: 0
      }
    })
  },

  getUserInfo() {
    return request({
      url: '//activity.video.qq.com/fcgi-bin/asyn_activity?otype=json&type=26&option=3&act_id=4241'
    })
  },

  setUserInfo(data) {
    return request({
      url: '//activity.video.qq.com/fcgi-bin/asyn_activity?otype=json&type=26&option=2&act_id=4241',
      data: data
    })
  },

  getStarList() {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_year_eggs_star',
        cmd: 65395
      }
    })
  },

  getAllEggCount () {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr',
        cmd: 5
      }
    })
  },

  getMoney () {
    return request({
      url: baseUrl,
      data: {
        name: 'spp_cny_egg_list_svr',
        cmd: 7
      }
    })
  }
}